// appcenter schema defined in appcenter.json
// appCenter is passed from the app -
export default (appCenterSchema, AppCenter) => {
  const { categories, tools } = appCenterSchema;

  const relevantCategories = categories.slice(0, -1);

  const result = [];
  const categoryResult = [];
  // Key here: routes are ordered specific -> less specific
  // So that for instance /<category>/<tool> goes to Tool BUT
  // /<category> correctly defaults to Category

  relevantCategories.forEach(category => {
    const { location } = category;
    // add details routes to results first
    category.sections.forEach(section => {
      section.items.forEach(item => {
        const tool = tools.find(tool => tool.name === item);
        // IMPORTANT if there is no match here tests will break
        // this compares a tool from the category section to the tool's name
        tool &&
          result.push({
            path: `appcenter/${category.location}/${tool.location}`,
            component: AppCenter,
            strict: true, // can remove once trailing slash bug is fixed
            exact: true
          });
      });
    });

    // save the category route for this category
    categoryResult.push({
      path: `appcenter/${location}`,
      component: AppCenter,
      exact: true
    });
  });

  // add all categories to result after all details are added
  result.push(...categoryResult);

  return result;
};
